import * as ng from '@angular/core';
import { Component } from '@angular/core';
import { LiveUserAuthority } from "src/lib/entity/live-user-authority";
import { CommonService } from 'src/lib/services/common-service'

@Component({
  selector: 'maglive-admin-dashboard-index',
  templateUrl: './dashboard-index.component.html',
  styleUrls: ['./dashboard-index.component.scss', '../../../../pages/admin/startbootstrap-sb-admin-gh-pages/src/scss/styles.scss']
})
export class DashboardIndexComponent implements ng.OnInit{
  authority: LiveUserAuthority;

  constructor(
    private commonService: CommonService
  ) { }

  ngOnInit(): void {
    this.commonService.authority.subscribe(data => 
      this.authority = data
    );
  }
}
